import { render, staticRenderFns } from "./SatsangiProfileAdd.vue?vue&type=template&id=b5ca3eda&"
import script from "./SatsangiProfileAdd.vue?vue&type=script&lang=js&"
export * from "./SatsangiProfileAdd.vue?vue&type=script&lang=js&"
import style0 from "./SatsangiProfileAdd.vue?vue&type=style&index=0&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports